module.exports = __webpack_public_path__ + "[1]/connect_with_team-227ffc56eb4e522e73c78faea646d0bd.svg";